(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rnc-backstage-pass"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rnc-pass')) {
    customElements.define('rnc-pass', class extends HTMLElement {
      connectedCallback() {
        const section = this.closest('section');
        this.card = this.querySelector('[data-card]');
        this.nameOut = this.querySelector('[data-name]');
        this.placeholder = this.nameOut.textContent;
        const input = section.querySelector('[data-name-input]');
        input?.addEventListener('input', () => {
          this.nameOut.textContent = input.value.trim() || this.placeholder;
        });
        const form = section.querySelector('[data-code-form]');
        form?.addEventListener('submit', (e) => {
          e.preventDefault();
          const code = form.querySelector('input').value.trim();
          if (!code) return;
          window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/collections/all');
        });
        if (matchMedia('(prefers-reduced-motion: reduce)').matches || !matchMedia('(hover: hover)').matches) return;
        this.onMove = (e) => {
          const r = this.card.getBoundingClientRect();
          const x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
          this.card.style.setProperty('--ry', ((x - 0.5) * 18).toFixed(2) + 'deg');
          this.card.style.setProperty('--rx', ((0.5 - y) * 14).toFixed(2) + 'deg');
          this.card.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
          this.card.style.setProperty('--my', (y * 100).toFixed(1) + '%');
        };
        this.onLeave = () => { ['--rx', '--ry', '--mx', '--my'].forEach((p) => this.card.style.removeProperty(p)); };
        this.addEventListener('pointermove', this.onMove);
        this.addEventListener('pointerleave', this.onLeave);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rnc-channels"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rnc-channels')) {
    customElements.define('rnc-channels', class extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i, true));
          tab.addEventListener('keydown', (e) => {
            const dir = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
            if (e.key === 'Home') { e.preventDefault(); this.select(0, true, true); }
            if (e.key === 'End') { e.preventDefault(); this.select(this.tabs.length - 1, true, true); }
            if (dir) { e.preventDefault(); this.select((i + dir + this.tabs.length) % this.tabs.length, true, true); }
          });
        });
        const strip = this.querySelector('.rnc-channels__tabs');
        if (strip) {
          const edge = () => {
            strip.classList.toggle('is-scrollable', strip.scrollWidth > strip.clientWidth + 2);
            strip.classList.toggle('is-end', strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 12);
          };
          strip.addEventListener('scroll', edge, { passive: true });
          new ResizeObserver(edge).observe(strip);
          edge();
        }
        this.addEventListener('shopify:block:select', (e) => {
          const i = this.tabs.findIndex((t) => t.contains(e.target) || t === e.target);
          if (i > -1) this.select(i, false);
        });
      }
      select(index, animate, focus) {
        this.tabs.forEach((tab, i) => {
          const on = i === index;
          const panel = this.querySelector('#' + tab.getAttribute('aria-controls'));
          tab.setAttribute('aria-selected', on);
          tab.tabIndex = on ? 0 : -1;
          if (!panel) return;
          panel.classList.toggle('is-off', !on);
          panel.inert = !on;
          if (on) panel.removeAttribute('aria-hidden'); else panel.setAttribute('aria-hidden', 'true');
          panel.classList.remove('is-entering');
          if (on && animate) { void panel.offsetWidth; panel.classList.add('is-entering'); }
        });
        const monitor = this.querySelector('[data-rnc-monitor]');
        if (monitor) {
          monitor.querySelectorAll('[data-screen]').forEach((s) => s.classList.toggle('is-on', Number(s.dataset.screen) === index));
          if (animate) { monitor.classList.remove('is-tuning'); void monitor.offsetWidth; monitor.classList.add('is-tuning'); }
        }
        if (focus) this.tabs[index].focus();
        this.tabs[index].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rnc-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rnc-signal-line')) {
    customElements.define('rnc-signal-line', class extends HTMLElement {
      connectedCallback() {
        this.path = this.querySelector('path');
        this.t = 0;
        this.pointer = null;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.draw = this.draw.bind(this);
        this.onMove = (e) => {
          const r = this.getBoundingClientRect();
          this.pointer = Math.min(Math.max((e.clientX - r.left) / r.width, 0), 1);
        };
        this.closest('section')?.addEventListener('pointermove', this.onMove, { passive: true });
        this.io = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          if (this.visible && !this.raf) this.raf = requestAnimationFrame(this.draw);
        });
        this.io.observe(this);
        if (this.reduced) this.render();
      }
      disconnectedCallback() {
        this.io?.disconnect();
        cancelAnimationFrame(this.raf);
        this.closest('section')?.removeEventListener('pointermove', this.onMove);
      }
      render() {
        let d = '';
        for (let x = 0; x <= 1200; x += 8) {
          const u = x / 1200;
          const env = Math.sin(u * Math.PI);
          const near = this.pointer === null ? 0 : Math.max(0, 1 - Math.abs(u - this.pointer) * 6);
          const amp = 10 * env + 16 * near;
          const y = 30 + Math.sin(x / 26 + this.t) * amp + Math.sin(x / 7 + this.t * 2.3) * 2.2 * env;
          d += (x ? ' L' : 'M') + x + ' ' + y.toFixed(1);
        }
        this.path.setAttribute('d', d);
      }
      draw() {
        this.raf = null;
        if (!this.visible || this.reduced) return;
        this.t += 0.035;
        this.render();
        this.raf = requestAnimationFrame(this.draw);
      }
    });
  }

  // Hero-Effekte: Video-Schleife nur sichtbar + mit Bewegung, Licht folgt dem Zeiger, Parallax beim Wegscrollen
  (() => {
    const init = (hero) => {
      if (!hero || hero.dataset.fx) return;
      hero.dataset.fx = '1';
      const motion = matchMedia('(prefers-reduced-motion: no-preference)');
      const media = hero.querySelector('[data-rnc-hero-media]');
      const inner = hero.querySelector('[data-rnc-hero-inner]');
      const glow = hero.querySelector('[data-rnc-hero-glow]');
      const video = hero.querySelector('.rnc-hero__video--loop');

      if (video && motion.matches) {
        const small = video.dataset.srcSmall && matchMedia('(max-width: 989px)').matches;
        // Beobachter am Element halten, sonst kann der Browser ihn verwerfen, bevor er feuert (am Handy beobachtet)
        hero._rncVideoIO = new IntersectionObserver(([e]) => {
          if (e.isIntersecting) {
            if (!video.getAttribute('src')) video.src = small ? video.dataset.srcSmall : video.dataset.src;
            video.play().then(() => video.classList.add('is-playing')).catch(() => {});
          } else if (video.getAttribute('src')) video.pause();
        }, { threshold: 0.15 });
        hero._rncVideoIO.observe(hero);
      }

      if (glow && motion.matches && matchMedia('(hover: hover)').matches) {
        hero.addEventListener('pointermove', (e) => {
          const r = hero.getBoundingClientRect();
          glow.style.setProperty('--gx', `${((e.clientX - r.left) / r.width) * 100}%`);
          glow.style.setProperty('--gy', `${((e.clientY - r.top) / r.height) * 100}%`);
          hero.classList.add('is-lit');
        }, { passive: true });
        hero.addEventListener('pointerleave', () => hero.classList.remove('is-lit'));
      }

      if (motion.matches) {
        let raf = null;
        const tick = () => {
          raf = null;
          const r = hero.getBoundingClientRect();
          const p = Math.min(1, Math.max(0, -r.top / r.height));
          media.style.setProperty('--rnc-hero-shift', `${(p * r.height * 0.25).toFixed(1)}px`);
          inner.style.setProperty('--rnc-hero-lift', `${(-p * 60).toFixed(1)}px`);
          inner.style.setProperty('--rnc-hero-fade', (1 - p * 0.9).toFixed(3));
        };
        const onScroll = () => { if (!raf) raf = requestAnimationFrame(tick); };
        (document.querySelector('.page-wrapper') || window).addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('scroll', onScroll, { passive: true });
        tick();
      }
    };
    const run = () => document.querySelectorAll('.rnc-hero').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rnc-soundcheck"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rnc-soundcheck')) {
    customElements.define('rnc-soundcheck', class extends HTMLElement {
      connectedCallback() {
        try { this.table = JSON.parse(this.querySelector('script[type="application/json"]').textContent); } catch (e) { this.table = []; }
        this.table = this.table.filter((r) => r.size && r.max).sort((a, b) => a.max - b.max);
        this.range = this.querySelector('[data-range]');
        this.cm = this.querySelector('[data-cm]');
        this.size = this.querySelector('[data-size]');
        this.hint = this.querySelector('[data-hint]');
        this.baseHint = this.hint.textContent;
        this.range.addEventListener('input', () => this.update());
        this.update();
      }
      update() {
        const v = Number(this.range.value);
        const min = Number(this.range.min), max = Number(this.range.max);
        this.range.style.setProperty('--fill', ((v - min) / (max - min)) * 100 + '%');
        this.cm.textContent = v;
        if (!this.table.length) return;
        const i = this.table.findIndex((r) => v <= r.max);
        const row = i === -1 ? this.table[this.table.length - 1] : this.table[i];
        this.size.textContent = row.size;
        const near = i > -1 && i < this.table.length - 1 && row.max - v <= 1;
        this.hint.textContent = near
          ? 'Grenze zu ' + this.table[i + 1].size + ': für lockeren Fall eine Größe größer.'
          : i === -1 ? 'Über der Tabelle: nimm die größte Größe oder schreib uns.' : this.baseHint;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
